import { render } from "./ContentAccordion.vue?vue&type=template&id=07cbffea"
import script from "./ContentAccordion.vue?vue&type=script&lang=js"
export * from "./ContentAccordion.vue?vue&type=script&lang=js"

import "./ContentAccordion.vue?vue&type=style&index=0&id=07cbffea&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__